import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'
import { moveElementToPath } from '../../object.util'

export const moveTraumaTriageCriteria = (pcr: any): IPcr => {
  try {
    if (pcr.ccHpiInjuryDetails) {
      const injuryDetails = pcr.ccHpiInjuryDetails

      if (injuryDetails.traumatriagecriteriahighrisk) {
        moveElementToPath(injuryDetails, 'traumatriagecriteriahighrisk', 'traumaTriageCriteriaHighRisk')
      }

      if (injuryDetails.traumaTriagecriteriamoderaterisk) {
        moveElementToPath(injuryDetails, 'traumaTriagecriteriamoderaterisk', 'traumaTriageCriteriaModerateRisk')
      }
    }

    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule moveTraumaTriageCriteria: ${error}`)
    throw error
  }
}
